import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import WorkSpace from './WorkSpace';
import { SOCKET_EVENTS } from '@src/pages/VisualActivation/constant';

const RoomDetail = ({
  connected,
  error,
  sendMessage,
}: {
  connected: boolean;
  error?: Error;
  sendMessage: (message: string, data?: any, skipAck?: boolean) => Promise<void>;
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  // Get roomId from URL params using React Router's useParams
  const location = useLocation();

  const room_id = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const roomId = params.get('room_id');
    return roomId ? decodeURIComponent(roomId) : '';
  }, [location.search]);

  useEffect(() => {
    if (connected || error) {
      setLoading(false);
    }
    if (connected && room_id) {
      sendMessage(SOCKET_EVENTS.SUBSCRIBE_ROOM, { room_id });
    }
  }, [connected, error, room_id, sendMessage]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return <WorkSpace roomId={room_id} sendMessage={sendMessage} />;
};

export default RoomDetail;
